import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Banner.module.css';
import BackgroundShadow from '../shared/BackgroundShadow';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import image from './images/Group.png';

const Banner: React.FC = () => {
    const navigate = useNavigate();

    const handleRequestDemo = () => {
        navigate('/contact');
    };

    return (
        <div className={styles.container}>
            <BackgroundShadow />

            <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                Approval Process
            </OptimizedMotionH1>
            <OptimizedMotionP className={styles.description} type="slide-down" delay={0.4}>
                The approval process streamlines content collaboration by allowing teams to review,
                comment, and approve assets in one place—ensuring brand consistency, faster feedback
                loops, and complete visibility from draft to publish.{' '}
            </OptimizedMotionP>

            <img src={image} alt="banner" className={styles.image} />
        </div>
    );
};

export default Banner;
